import React from "react";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"

const PanVerificationPage = ({
  pan,
  setPan,
  panError,
  setPanError,
  panStatus,
  setPanStatus,
  panChecking,
  setPanProfile,
  lastFetchedPanRef,
  checkPanOnEnter,
  email,
  setEmail,
  emailError,
  setEmailError,
  checkEligibility,
  checking,
  setScreen,
}) => {
  return (
    <section className="fw-screen fw-screen--plain fw-fade">
       <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>
      {/* <p className="fw-progress-label">Processing 10%</p>

      <div className="fw-progress">
        <span style={{ width: "10%" }} />
      </div> */}

<div className="fw-basic-details">
  <h1 className="fw-title">Basic Details</h1>

  <p className="fw-sub">
    Enter the below details to check your eligibility quickly.
  </p>
</div>

      <label className="fw-field">
        <span>Enter your PAN Number</span>

        <input
          value={pan}
          maxLength={10}
          placeholder="ASDFR3128J"
          autoCapitalize="characters"
          onChange={(e) => {
            const next = e.target.value
              .toUpperCase()
              .replace(/[^A-Z0-9]/g, "")
              .slice(0, 10);

            setPan(next);

            if (next.length < 10) {
              setPanError("");
              setPanStatus("");
              setPanProfile(null);
              lastFetchedPanRef.current = "";
              return;
            }

            checkPanOnEnter(next);
          }}
        />

        {panChecking && (
          <em className="fw-field__info">
            Checking PAN status...
          </em>
        )}

        {!panChecking && panError && (
          <em>{panError}</em>
        )}

        {!panChecking && !panError && panStatus && (
          <em className="fw-field__ok">
            {panStatus}
          </em>
        )}
      </label>

      <label className="fw-field">
        <span>Enter your Email ID</span>

        <input
          type="email"
          value={email}
          placeholder="joey657@gmail.com"
          onChange={(e) => {
            setEmail(e.target.value);
            setEmailError("");
          }}
        />

        {emailError && (
          <em>{emailError}</em>
        )}
      </label>

      <div className="fw-actions">
        <button
          type="button"
          className="fw-btn fw-btn--ghost"
          onClick={() => setScreen("/apply-new/location")}
        >
          Back
        </button>

        <button
          type="button"
          className="fw-btn fw-btn--primary"
          onClick={checkEligibility}
          disabled={checking}
        >
          {checking
            ? "Checking..."
            : "Check Eligibility"}
        </button>
      </div>
    </section>
  );
};

export default PanVerificationPage;